import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    userGuides: [],
    totalUserGuides: 0,
    selectAllField: false,
    selectedUserGuides: [],
    viewUserGuide: null
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
